var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeaderboard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3219 5.27397C17.2447 5.03714 17.0399 4.8644 16.7937 4.82866L14.4506 4.48811L13.4023 2.36461C13.2925 2.14141 13.065 2 12.8159 2C12.5667 2 12.3392 2.14141 12.2293 2.36461L11.1811 4.48815L8.83759 4.8287C8.59138 4.86448 8.3865 5.03717 8.30943 5.27401C8.23236 5.51084 8.29666 5.77088 8.47513 5.94467L10.1713 7.59755L9.77048 9.93129C9.72829 10.1768 9.82927 10.425 10.0308 10.5713C10.2327 10.7182 10.4997 10.7363 10.7199 10.6211L12.816 9.51923L14.9117 10.6211C15.1369 10.7393 15.403 10.7149 15.6008 10.5713C15.8023 10.425 15.9033 10.1769 15.8611 9.93153L15.4607 7.59755L17.1564 5.94467C17.3347 5.77088 17.3985 5.51081 17.3219 5.27397Z",
    fill: "#E6ECF3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4312 11.9688H10.1972C9.8359 11.9688 9.54297 12.2617 9.54297 12.623V22.0005H16.0854V12.623C16.0854 12.2617 15.7925 11.9688 15.4312 11.9688Z",
    fill: "#E6ECF3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.65426 14.5859C3.29293 14.5859 3 14.8789 3 15.2402V21.4835C3 21.7692 3.2316 22.0008 3.51726 22.0008H8.234V14.5859H3.65426Z",
    fill: "#E6ECF3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9733 17.2012H17.3936V21.999H22.1103C22.396 21.999 22.6276 21.7674 22.6276 21.4817V17.8554C22.6275 17.4941 22.3346 17.2012 21.9733 17.2012Z",
    fill: "#E6ECF3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaderboard);
export default __webpack_public_path__ + "static/media/leaderboard.c7a2af1cd2fedd21b0482851856f1c7c.svg";
export { ForwardRef as ReactComponent };